import proxy from "api/proxy";
import moves from "./ModelStockMove";
import { getStorage, setStorage } from "store/local";
import tools from "tools/dates";
import AddProduct from "../Components/AddProduct";

let today = tools.dateToday();
const ctxSession = getStorage("ctxSession");

function ComponentAddProduct({ record }) {
  return AddProduct("stock.shipment.internal", record);
}

const onPrintBrowser = async (record) => {
  const { effective_date, from_location, to_location, number, state, moves } =
    record;

  const formattedDate = new Date(effective_date).toLocaleDateString("es-CO");

  const lineas = (record["outgoing_moves."] || [])
    .map((move, index) => {
      return `
      <tr>
        <td>${index + 1}</td>
        <td>${move.product?.rec_name || move.product?.name} x  ${move.quantity}</td>
      </tr>
    `;
    })
    .join("");

  const contenidoHTML = `
    <html>
      <head>
        <title>Comprobante de Transferencia</title>
        <style>

          body {
            font-family: sans-serif;
            font-size: 2.8mm;
            padding: 20px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
            font-size: 2.2mm;

          }
          th, td {
            border: 1px solid #333;
            padding: 5px;
            text-align: left;
            font-size: 2.5mm;

          }
          .firma {
            margin-top: 60px;
            text-align: center;
          }
          .firma-linea {
            border-top: 1px solid #000;
            width: 200px;
            margin: 0 auto;
            margin-top: 40px;
          }
        </style>
      </head>
      <body>
        <h2>Comprobante de Transferencia</h2>
        <p><strong>Fecha:</strong> ${formattedDate}</p>
        <p><strong>Desde:</strong> ${from_location?.rec_name}</p>
        <p><strong>Hacia:</strong> ${to_location?.rec_name}</p>
        <p><strong>Número:</strong> ${number}</p>
        <p><strong>Estado:</strong> ${state}</p>

        <h3>Líneas de Productos</h3>
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Producto</th>
            </tr>
          </thead>
          <tbody>
            ${lineas}
          </tbody>
        </table>

        <div class="firma">
          <div class="firma-linea"></div>
          <p>Firma Responsable</p>
        </div>
      </body>
    </html>
  `;

  const ventana = window.open("", "", "width=800,height=600");
  ventana.document.open();
  ventana.document.write(contenidoHTML);
  ventana.document.close();
  ventana.focus();
  ventana.print();
};

const defaultWarehouse = async () => {
  const user = ctxSession?.user;
  console.log(ctxSession, "session");

  const { data, error } = await proxy.search(
    "res.user",
    [["id", "=", user]],
    [
      "id",
      "warehouse.name",
      "warehouse.input_location.name",
      "warehouse.input_location.rec_name",
      "warehouse.storage_location.name",
    ],
  );
  if (data && data.length > 0) {
    const warehouse = data[0]["warehouse."];
    console.log(warehouse?.["storage_location."], "warehousewarehouse");

    return warehouse?.["storage_location."];
  }
};
const visibleWait = (field, record) => {
  console.log(record, "visible wair");

  return record.number !== "" && record.state === "draft";
};
const visibleSave = (field, record) => {
  return !record.number;
};

const visibleAssigned = (field, record) => {
  return record.state === "waiting";
};

const visibleDone = (field, record) => {
  return record.state === "assigned";
};

const visiblePrint = (field, record) => {
  return record.state === "done" || record.state === "draft";
};
const visibleMoves = (field, record) => {
  console.log(record, "visibleMoves");

  return record?.state === "draft" || !record.state;
};
const visibleOutgoingMoves = (field, record) => {
  return (
    record.state === "waiting" ||
    record.state === "assigned" ||
    record.state === "done"
  );
};

async function onLocation(rec, store) {
  const _session = { ...getStorage("ctxSession") };
  console.log("paso por aca para actualizar", rec);
  _session.locations = [rec?.from_location.id];
  await setStorage("ctxSession", _session);
}

const getView = () => {
  let DictCtxView = {
    // model: "stock.shipment.out.return",
    model: "stock.shipment.internal",
    selectable: true,
    activeSearch: true,
    limit: 50,
    domain: ["planned_start_date", "=", `${today}`],
    // domain: [["warehouse", "=", ctxSession?.locations[0]]],
    form_action: ["save", "edit", "add"],
    table_action: ["open", "add"],
    webfields: {
      number: { type: "char", readOnly: true, searchable: true },
      effective_date: {
        type: "date",
        default: today,
        // readOnly: true,
      },
      planned_start_date: {
        type: "date",
        default: today,
        // readOnly: true,
      },
      // planned_date: {
      //   type: "date",
      //   default: today,
      //   readOnly: true,
      // },
      state: {
        type: "char",
        readOnly: true,
        translate: true,
      },
      invoice_state: {
        type: "char",
        readOnly: true,
        translate: true,
      },

      from_location: {
        type: "many2one",
        model: "stock.location",
        recSearch: () => [["type", "=", "storage"]],
        // readOnly: true,
        default: defaultWarehouse,
        withChange: onLocation,
      },

      to_location: {
        type: "many2one",
        model: "stock.location",
        recSearch: () => [["type", "=", "storage"]],
      },

      moves: {
        type: "one2many",
        model: "stock.move",
        ctxView: moves,
        required: true,
        readOnly: { state: ["quotation"] },
        visible: visibleMoves,
      },
      outgoing_moves: {
        type: "one2many",
        model: "stock.move",
        ctxView: moves,
        visible: visibleOutgoingMoves,
      },
      reference: {
        type: "custom_button",
        model: "stock.shipment.internal",
        Component: ComponentAddProduct,
      },
      save: {
        type: "button",
        button_method: "create",
        style: "!w-full",
        color: "bluePresik",
        visible: visibleSave,
      },
      wait: {
        type: "button",
        button_method: "wait",
        style: "!w-full",
        visible: visibleWait,
      },
      assigned: {
        type: "button",
        button_method: "assign",
        style: "!w-full",
        color: "amber",
        visible: visibleAssigned,
      },
      done: {
        type: "button",
        button_method: "done",
        style: "!w-full",
        color: "blue",

        visible: visibleDone,
        // visible: ()=> return true
      },

      print: {
        type: "button",
        method: onPrintBrowser,
        type: "button",
        button: onPrintBrowser,
        style: "!w-full !uppercase",
        color: "blue",
        visible: visiblePrint,
        // visible: ()=> return true
      },
    },
    webform: [
      { name: "number" },
      { name: "state" },
      { name: "effective_date" },
      { name: "planned_start_date" },
      { name: "from_location" },
      { name: "to_location" },
      // { name: "warehouse" },
      { name: "reference" },
      { name: "moves" },
      { name: "outgoing_moves" },
      {
        id: "buttons",
        grid: [
          { name: "save" },
          { name: "wait" },
          { name: "assigned" },
          { name: "done" },
          { name: "print" },
        ],

        size: [4, 4],
        span: "col-span-2",
      },
    ],
    webtree: [
      { name: "number", width: "20%" },
      { name: "from_location", width: "20%" },
      { name: "to_location", width: "20%" },
      // { name: "warehouse" },
      { name: "state", width: "20%" },
    ],
  };

  return DictCtxView;
};

export default { ctxView: getView };
